import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'
import kubun from 'config/kubun.json'

export const SaikenMeimokuKbn = props => {
  const options = kubun.saiken_meimoku_kbn

  return <Dropdown.Standard options={options} {...props} />
}
